<section class="webinarTopBanner">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="topBannerWrapper">
            <div class="top-banner-left">
              <h1>AI for Accuracy in Research and Academic Writing</h1>
            </div>
            <div class="top-banner-right">
              <div class="speaker-img">
                <img src="../../../../assets/images/webinar/kk.png" alt="speaker KK" class="img-fluid" />
              </div>
              <div class="speaker-img">
                <img src="../../../../assets/images/webinar/piyush.png" alt="speaker piyush" class="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="goBack">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <a [routerLink]="['/webinars']"><i class="fa fa-long-arrow-left"></i>All Webinars</a>
            </div>
        </div>
    </div>
  </section>
  
  <section class="section-pd">
    <div class="trinka_container">
      <div class="row">
        <div class="col-md-7 col-lg-7">
          <div class="dots">
            <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
            <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
          </div>
          <div class="trinka-title">
            <p>In today’s digital age, achieving high accuracy in academic writing is paramount for researchers and scholars. With the increasing reliance on AI tools in academia, it’s crucial to understand how to leverage these tools effectively to <b class="bold">enhance accuracy and precision in scholarly writing</b>.</p>
          </div>
          <div class="trinka-title mb-0">
            <h2>Key Benefits for Webinar Attendees:</h2>
            <ul class="bullets-pt">
              <li>Gain actionable insights into using <a [routerLink]="['/grammar-checker']" class="text-link">AI tools for ensuring high accuracy in academic writing</a></li>
              <li>Understand the differences among key AI tools and their specific strengths</li>
              <li>Learn effective strategies for utilizing AI tools to explore most relevant and recent literature</li>
              <li>Learn to fine-tune and optimize AI writing tools to your academic writing needs</li>
              <li>Witness live demonstrations showcasing cutting-edge features of <a href="https://www.read.enago.com/" target="_blank" rel="noopener noreferrer" class="text-link">Enago Read</a>, <a href="https://www.read.enago.com/copilot/" target="_blank" rel="noopener noreferrer" class="text-link">Copilot</a>, and <a [routerLink]="['/']" class="text-link">Trinka AI</a></li>
            </ul>
          </div>
          <div class="trinka-title">
            <p>Academic writing demands meticulous attention to detail and accuracy to ensure research credibility and uphold integrity. However, researchers often face challenges in maintaining accuracy amidst the vast amount of data and literature available. AI tools offer promising solutions to address many of these challenges by providing advanced capabilities, but the right tools and strategies need to be used for the right task.</p>
            <p>The session focuses accuracy and precision in the various stages of research lifecycle and suggests best practices and tools. These include:</p>
            <ul class="bullets-pt">
                <li>Knowledge discovery and <a href="https://www.read.enago.com/" target="_blank" rel="noopener noreferrer" class="text-link">literature review</a></li>
                <li>Fine-tuning research methodology</li>
                <li>Data sourcing and analysis</li>
                <li>Sharing research findings using tables, figures, and infographics</li>
                <li><a [routerLink]="['/features/citation-checker']" class="text-link">Citations</a> and attribution</li>
                <li>Discipline-specific terminology</li>
                <li>Language and <a [routerLink]="['/grammar-checker']" class="text-link">grammar refinement</a></li>
                <li>Ensuring <a [routerLink]="['/features/consistency-check']" class="text-link">consistency</a> and style</li>
            </ul>
          </div>
        </div>
        <div class="col-md-5 col-lg-4 offset-lg-1">
            <div class="webinar-video">
                <div class="webinar-img">
                    <button type="button" data-toggle="modal" data-target="#webinarVideo2">
                        <img src="/assets/images/webinar/webinar-2.png" class="img-fluid" loading="lazy" alt="trinka webinars" />
                        <span></span>
                    </button>
                </div>
                <!-- <app-upcoming-event></app-upcoming-event> -->
                <div class="partner-with-us">
                  <h5>Partner with us!</h5>
                  <p>Co-host a FREE AI webinar at your university.</p>
                  <div class="btn-group">
                      <a [routerLink]="['/webinars']" fragment="getInTouch" class="filled-btn w-100">Get in Touch</a>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </section>
  
  <section class="section-pd abt-session">
    <div class="trinka_container">
      <div class="row">
        <div class="col-12">
          <div class="session-wrapper">
            <div class="session-titles">
              <div class="dots">
                <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
                <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
              </div>
              <div class="trinka-title mb-0">
                <h2 class="text-white">Who Should Attend This Session?</h2>
              </div>
            </div>
            <div class="session-body">
              <ul class="bullets-pt">
                <li>Graduate students</li>
                <li>Early-stage researchers</li>
                <li>Doctoral & postdoctoral students</li>
                <li>Established researchers and academicians</li>
                <li>Editors</li>
                <li>Peer Reviewers</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <section class="section-pd speaker-section">
    <div class="trinka_container">
      <div class="row">
        <div class="col-12">
          <div class="dots">
            <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
            <img src="../../../../assets/images/webinar/dots.svg" alt="dots"/>
          </div>
          <div class="trinka-title mb-40">
            <h2>Speakers' Profiles</h2>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-4">
          <div class="speaker-box">
            <div class="img">
              <img src="../../../../assets/images/webinar/kk-tumbnail.png" alt="kk" loading="lazy" />
            </div>
            <h4>Dr. Krishna Kumar Venkitachalam</h4>
            <p>Innovation Officer at <br/>Trinka AI</p>
          </div>
        </div>
        <div class="col-lg-8 col-md-8">
          <p>Dr. KK is an orthopedic surgeon by qualification with 15+ years of experience in academic publishing under various roles, including manuscript editing, manuscript writing, editor training, author education, language technology solutions, and innovation. As an editor/writer, he has helped hundreds of authors/researchers publish their research in leading journals worldwide. Being passionate about science communication and teaching, he has conducted several interactive training programs and author workshops. These included touring workshops in India and internationally along with online workshops in collaboration with universities and publishers. With his background in academia, experience in science communication experience, and affinity towards technological solutions, he plays a role as a consultant in the integration of new technologies to publishing platforms and for designing customized publication solutions for institutions and publishers.</p>
        </div>
        <div class="col-12">
          <hr />
        </div>
        <div class="col-lg-4 col-md-4">
          <div class="speaker-box">
            <div class="img">
              <img src="../../../../assets/images/webinar/piyush-tumbnail.png" alt="piyush" loading="lazy" />
            </div>
            <h4>Piyush Agarwal</h4>
            <p>Lead Product Manager at<br/>Trinka AI</p>
          </div>
        </div>
        <div class="col-lg-8 col-md-8">
          <p>Piyush has 12 years of experience in designing and building cutting-edge digital products in the education, technology, and academic publishing industries. Over the period of last decade, as a product manager, he has worked with large corporates, SMEs, start-ups, and start-up accelerator, adding immense value to their businesses. As a developer turned product manager, he uniquely stands at the intersection of business and technology with experience in both the Corporate and start-up world. Piyush is Lead Product Manager at Crimson and heads the product and design teams of Trinka.ai and Enago Read. Piyush is focused on leveraging the power of AI to solve the researchers’ problems and build a resilient tech ecosystem for the entire academic publishing industry.</p>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal fade" id="webinarVideo2" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" width="100%" height="642" src="https://www.youtube.com/embed/cgB1J2FYP-0"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>